import { styled } from "@mui/material/styles";
import { theme } from "./TableStyles";

export const ModalStyle = styled("div")(({ property }) => ({
    padding: "8px",
    "& .MuiDialogTitle-root": {
        margin: "24px",
    },
    "& .MuiTypography-h6": {
        fontFamily: "Muli, sans-serif !important",
        fontWeight: "900 !important",
        display: "flex",
    },
    "& #headButton": {
        position: "absolute",
        right: "20px",
        top: "30px",
    },
    "& #secondButton": {
        position: "absolute",
        right: "50px",
        top: "30px",
    },
    "& .MuiDialogActions-root": {
        margin: "24px",
        padding: "0",
    },
    "& .MuiButton-root": {
        backgroundColor: JSON.parse(property)
            ? "#edf0f4 !important"
            : "#3743aa !Important",
        color: JSON.parse(property) ? "#969ba0 !important" : "white",
        fontWeight: "bold !important",
        textTransform: "none !important",
        fontFamily: "Muli, sans-serif !important",
        fontSize: "16px !important",
    },
    "& #buttonCancel": {
        background: "white !important",
        border: "1px solid #3743AA !important",
        color: "#3743AA !important",
        marginRight: "8px !important",
        "&:hover": {
            border: "1px solid #3743AA !important",
            backgroundColor: "#3743aa !important",
            color: "white !important",
        },
    },
    "& #buttonDelete": {
        backgroundColor: "#3743aa !important",
        color: "white !important",
    },
    "& #buttonText": {
        backgroundColor: "inherit !important",
        color: "inherit !important",
    },
    "& #subtitle": {
        fontStyle: "italic",
        paddingTop: "6px !important",
        paddingLeft: "10px !important",
    },
    "& #subtitle_2": {
        fontStyle: "italic",
        padding: "0px !important",
        paddingBottom: "25px !important",
    },
    "& .MuiTabs-indicator": {
        background: "none",
    },
    "& .MuiTab-root": {
        width: "50%",
        textTransform: "none",
        fontWeight: "bold",
        color: "#3E3E42 !important",
        fontFamily: "Muli,sans-serif !important",
        backgroundColor: "none",
    },
    "& #tabOption": {
        width: "25% !important",
    },
    "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root": {
        height: "40px",
    },
    "& .MuiAccordionSummary-content": {
        alignItems: "center",
    },
}));

export const WidgetStyle = styled("div")(({ property }) => ({
    width: "-webkit-fill-available",
    "& .MuiTypography-root": {
        fontFamily: "Muli, sans-serif !important",
        // fontWeight: "900 !important",
        display: "flex",
    },
    "& .MuiCardContent-root": {
        margin: "24px 0px",
    },
    "& .MuiCardActions-root": {
        margin: "24px 0px",
        padding: "0",
        placeContent: "end",
    },
    "& .MuiButton-root": {
        fontWeight: "bold !important",
        fontSize: "16px !important",
        backgroundColor:
            property && JSON.parse(property)
                ? "#edf0f4 !important"
                : `${theme.palette.primary.main} !important`,
        color:
            property && JSON.parse(property) ? "#969ba0 !important" : "white",
    },
    "& #buttonCancel": {
        background: "white !important",
        border: `1px solid ${theme.palette.primary.main} !important`,
        color: `${theme.palette.primary.main} !important`,
        marginRight: "8px !important",
        "&:hover": {
            border: `1px solid ${theme.palette.primary.main} !important`,
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: "white !important",
        },
    }
}));
